import type { RouterInputs, RouterOutputs } from "@blis/trpc/react";

export type Selected = string | number | null | undefined;

export type LocationState = {
  from?: string;
  selected?: Selected;
  open?: Record<string, string>;
};

export type { RouterInputs, RouterOutputs };

export type AccessionRouter = RouterOutputs["accession"];
export type AnonRouter = RouterOutputs["anon"];
export type InstrumentRouter = RouterOutputs["instruments"];
export type InstrumentResultSetRouter = RouterOutputs["instrumentResults"];
export type SampleRouter = RouterOutputs["samples"];
export type PanelRouter = RouterOutputs["panels"];
export type ReportRouter = RouterOutputs["reports"];
export type SubjectRouter = RouterOutputs["subjects"];
export type TestRouter = RouterOutputs["tests"];

export type TAccession = AccessionRouter["list"]["all"][0];
export type TView = AccessionRouter["views"]["list"][number];

export type TAccessionStatus = NonNullable<TAccession["status"]>;
export type TTestType = NonNullable<TAccession["testType"]>;
export type TPriority = NonNullable<TAccession["priority"]>;
export type TInvoiceInstruction =
  AccessionRouter["invoiceInstructions"][number];

export type TAccessionDetail = AccessionRouter["get"];
export type TTestOrder = AccessionRouter["testOrders"][0];
export type TTestOrderResult = TTestOrder["results"][0];
export type TSample = AccessionRouter["samples"][0];
export type THold = AccessionRouter["holds"][0];
export type TAccessionComment = AccessionRouter["comments"]["list"][number];
export type TAccessionUpload = AccessionRouter["uploads"]["list"][number];

export type TInstrument = InstrumentRouter["list"][0];
export type TInstrumentResultSet = InstrumentResultSetRouter["list"][0];
export type TInstrumentResultItem = TInstrumentResultSet["results"][0];

export type TTube = SampleRouter["tubes"][0];
export type TTubeWithFields = SampleRouter["tubesWithFields"][0];

export type TPanel = PanelRouter["all"][0];

export type TSubjectDetail = SubjectRouter["get"];
export type TSubjectAccession = SubjectRouter["accessions"][0];

export type TTestSpec = TestRouter["all"][0];

export type TReport = ReportRouter["generate"];

export type TAuthProvider = AnonRouter["authProvider"];

export type UploadReturn =
  | {
      type: "results";
    }
  | {
      type: "document";
    };

// Enums

export enum SampleTempType {
  Ambient = "ambient",
  Frozen = "frozen",
  Refrigerated = "refrigerated",
}

export enum TempUnit {
  C = "C",
  F = "F",
}

export enum ArchiveType {
  Retain = "RETAIN",
  Discard = "DISCARD",
  Offsite = "OFFSITE",
}
